// extracted by mini-css-extract-plugin
export var bottomText = "DataPrivacy-module--bottomText--hwzn9";
export var bottomTextWrapper = "DataPrivacy-module--bottomTextWrapper--+CM1J";
export var cardsSection = "DataPrivacy-module--cardsSection--m8JNH";
export var dataPrivacyWrapper = "DataPrivacy-module--dataPrivacyWrapper--2t8gE";
export var description = "DataPrivacy-module--description--kWHc3";
export var headerSection = "DataPrivacy-module--headerSection--k4Z3Q";
export var sectionTitle = "DataPrivacy-module--sectionTitle--Ahawa";
export var sectionTitleWrapper = "DataPrivacy-module--sectionTitleWrapper--reS8u";
export var subtitle = "DataPrivacy-module--subtitle--zQn+3";
export var title = "DataPrivacy-module--title--IWzyx";